if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => {
        this.change_quantity(1 * this.step);

        const parent = this.add.parentElement;
        if (!parent) return;

        const siblings = Array.from(parent.parentElement.children).filter(
          el => el !== parent
        );

        siblings.forEach(sibling => {
          const addedBtn = sibling.querySelector('.quick-add-button.added');
          if (addedBtn) {
            addedBtn.classList.remove('added');
          }
        });
      });

      this.validateQtyRules();
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      let quantity = Number(this.input.value);
      if (isNaN(quantity)) quantity = 1;

      if (this.input.getAttribute('min') > quantity + change) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < quantity + change) {
          return;
        }
      }

      quantity += change;
      quantity = Math.max(quantity, 1);
      this.input.value = quantity;
      this.input.dispatchEvent(this.changeEvent);
      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

function initializeQuantityScript() {
  if (document.documentElement.dataset.quantityScriptInitialized === 'true') {
    return;
  }

  document.documentElement.dataset.quantityScriptInitialized = 'true';
  initializeProductActions();
  setupEventDelegation();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeQuantityScript, { once: true });
} else {
  initializeQuantityScript();
}

function initializeProductActions() {
  document.querySelectorAll('.product-actions').forEach(function(wrapper) {
    if (wrapper.dataset.initialized) return;

    const qtyInput = wrapper.querySelector('.quantity__input');
    const minusBtn = wrapper.querySelector('.minus');
    const plusBtn = wrapper.querySelector('.plus');
    const quickAddBtn = wrapper.querySelector('.quick-add-btn');

    if (!qtyInput || !minusBtn || !plusBtn || !quickAddBtn) return;

    wrapper.dataset.initialized = 'true';

    minusBtn.type = 'button';
    plusBtn.type = 'button';
    qtyInput.setAttribute('min', '0');

    updateProductState(wrapper);

    qtyInput.addEventListener('input', function() {
      let value = qtyInput.value;
      if (value !== '') qtyInput.value = parseInt(value) || 0;
      updateProductState(wrapper);
    });

    qtyInput.addEventListener('change', function() {
      updateProductState(wrapper);
    });
  });
}

function setupEventDelegation() {
  document.addEventListener(
    'click',
    function(e) {
      if (e.target.classList.contains('plus') && e.target.tagName === 'BUTTON') {
        const wrapper = e.target.closest('.product-actions');
        const qtyInput = wrapper?.querySelector('.quantity__input');
        if (!wrapper || !qtyInput) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        qtyInput.value = (parseInt(qtyInput.value) || 0) + 1;
        updateProductState(wrapper);
        return false;
      }

      if (e.target.classList.contains('minus') && e.target.tagName === 'BUTTON') {
        const wrapper = e.target.closest('.product-actions');
        const qtyInput = wrapper?.querySelector('.quantity__input');
        if (!wrapper || !qtyInput) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        let qty = parseInt(qtyInput.value) || 0;
        qtyInput.value = qty > 0 ? qty - 1 : 0;
        updateProductState(wrapper);
        return false;
      }

      if (e.target.classList.contains('quick-add-btn') && e.target.tagName === 'BUTTON') {
        const btn = e.target;
        const wrapper = btn.closest('.product-actions');
        const originalText = btn.textContent;
        const hadAddedClass = btn.classList.contains('added');
        const wasDisabled = btn.hasAttribute('disabled');

        btn.classList.add('added');
        btn.textContent = 'Added';

        setTimeout(() => {
          if (!hadAddedClass) {
            btn.classList.remove('added');
          }

          btn.textContent = originalText;

          if (wasDisabled) {
            btn.setAttribute('disabled', 'disabled');
          } else {
            btn.removeAttribute('disabled');
          }

          if (wrapper) {
            updateProductState(wrapper);
          }
        }, 5000);
      }
    },
    true
  );

  document.addEventListener('input', function(e) {
    if (!e.target.classList.contains('quantity__input')) return;
    const wrapper = e.target.closest('.product-actions');
    if (wrapper) updateProductState(wrapper);
  });

  document.addEventListener('change', function(e) {
    if (!e.target.classList.contains('quantity__input')) return;
    const wrapper = e.target.closest('.product-actions');
    if (wrapper) updateProductState(wrapper);
  });
}

function updateProductState(wrapper) {
  const qtyInput = wrapper.querySelector('.quantity__input');
  const minusBtn = wrapper.querySelector('.minus');
  const quickAddBtn = wrapper.querySelector('.quick-add-btn');

  if (!qtyInput || !minusBtn || !quickAddBtn) return;
  if (quickAddBtn.classList.contains('added')) return;

  let qty = parseInt(qtyInput.value);
  if (isNaN(qty) || qty < 0) {
    qty = 0;
  }

  if (qty > 0) {
    quickAddBtn.removeAttribute('disabled');
    minusBtn.classList.remove('disabled');
  } else {
    quickAddBtn.setAttribute('disabled', 'disabled');
    minusBtn.classList.add('disabled');
  }
}

function refreshProductActions() {
  initializeProductActions();
}

document.addEventListener('click', function(event) {
  const btn = event.target.closest('.quick-add-button');
  if (!btn) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const actions = btn.closest('.product-actions');
  if (!actions) return;

  const variantInput = actions.querySelector('.wc_variant_id');
  const qtyInput = actions.querySelector('.quantity__input');
  if (!variantInput || !qtyInput) return;

  const variant_id = variantInput.value;
  const var_quantity = parseInt(qtyInput.value, 10);
  if (!variant_id || var_quantity <= 0) return;

  const time = new Date().toISOString();
  const item = {
    id: variant_id,
    quantity: var_quantity
  };

  if (document.body.classList.contains('template-collection-outside-sow')) {
    item.properties = {
      _time: time
    };
  }

  const formData = {
    items: [item]
  };

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(res => {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(() => {
      qtyInput.value = 0;

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.refresh?.();
        cartDrawer.open?.();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(err => console.error(err));
});
